<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="抢单日期">
						<div class="block">
							<!-- <el-date-picker 
							      v-model="searchInfo.timer"
							      type="date"
								  value-format="yyyy-MM-dd"
							      placeholder="开始日期">
							</el-date-picker> -->
							<div class="block">
								<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd"
									type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
									>
								</el-date-picker>
							</div>
						</div>
					</el-form-item>
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="edit('')">设置额度</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="recardData.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="subOrderDate" label="抢单日期" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="subOrderAmount" label="总额度" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="subOrderLeft" label="剩余额度" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="subOccupyTotal" label="占用额度" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="subOccupy" label="占用剩余额度" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button v-if="newTimer > scope.row.subOrderDate" size="small" type="text" @click="chakan(scope.row.id)">查看</el-button>
					<el-button v-else size="small" type="text" @click="edit(scope.row.id)">编辑</el-button>
					
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="recardData.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="recardData.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		<el-dialog :title="Quotatitle" :visible.sync="setQuotaVisible" width="40%" :close-on-click-modal="false">
			<el-form  :model="ationFrom" size="medium" width="70%"  label-position="right" label-width="100px" :close-on-click-modal="false">
				<el-form-item v-if="this.Quotatitle == '编辑额度'" label="开始日期" class='tiny' cleartable>
					<el-date-picker disabled
					      v-model="ationFrom.subOrderDate"
					      type="date"
						  value-format="yyyy-MM-dd"
					      placeholder="开始日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item v-else label="开始日期" class='tiny' cleartable>
					<el-date-picker
					      v-model="ationFrom.subOrderDate"
						  @change="dateChange"
					      type="date"
						  value-format="yyyy-MM-dd"
					      placeholder="开始日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="总额度" class='tiny' cleartable>
					<el-input style="width: 200px;" v-model="ationFrom.subOrderAmount" placeholder="请输入总额度"></el-input>
				</el-form-item>
				<!-- <div v-if="this.Quotatitle == '编辑额度'">
					<el-form-item label="占用额度" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="ationFrom.subOrderLeft" placeholder="请输入剩余额度"></el-input>
					</el-form-item>
					<el-form-item label="占用剩余额度" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="ationFrom.subOccupy" placeholder="请输入指定占用额度"></el-input>
					</el-form-item>
				</div> -->
			</el-form>
			<div style="text-align: center;margin-top: 30px">
				<el-button @click="setQuotaVisible = false">取 消</el-button>
				<el-button v-if="this.Quotatitle == '编辑额度'" type="primary" @click="updata">编 辑</el-button>
				<el-button v-else type="primary" @click="set">保 存</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="查看详情" :visible.sync="chakanVisible" width="40%" :close-on-click-modal="false">
			<el-form  :model="ationFrom" size="medium" width="70%" label-position="right" label-width="100px"  :close-on-click-modal="false">
				<el-form-item  label="开始日期" class='tiny' cleartable>
					<el-date-picker disabled
					      v-model="ationFrom.subOrderDate"
					      type="date"
						  value-format="yyyy-MM-dd"
					      placeholder="开始日期"
						  
						  >
					</el-date-picker>
				</el-form-item>
				<el-form-item label="总额度" class='tiny' cleartable>
					<el-input style="width: 200px;" disabled v-model="ationFrom.subOrderAmount" ></el-input>
				</el-form-item>
				<el-form-item label="剩余额度" class='tiny' cleartable>
					<el-input style="width: 200px;" disabled v-model="ationFrom.subOrderLeft" ></el-input>
				</el-form-item>
				<div>
					<el-form-item label="占用额度" class='tiny' cleartable>
						<el-input style="width: 200px;" disabled v-model="ationFrom.subOccupyTotal" ></el-input>
					</el-form-item>
					<el-form-item label="占用剩余额度" class='tiny' cleartable>
						<el-input style="width: 200px;" disabled v-model="ationFrom.subOccupy" ></el-input>
					</el-form-item>
				</div>
			</el-form>
			<div style="text-align: center;margin-top: 30px">
				<el-button @click="chakanVisible = false">关 闭</el-button>
				<!-- <el-button type="primary" @click="sure2">确 认</el-button> -->
			</div>
		</el-dialog>
		
		
		
	</div>
</template>

<script>
	export default {
		data(){
			return{
				searchInfo:{},
				loading:false,
				setQuotaVisible:false,
				chakanVisible:false,
				ationFrom:{
					subOrderDate:this.getnowData()
					
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				recardData:{},
				Quotatitle:'',
				newTimer:'',
				recadId:'',
			}
		},
		methods:{
			//查询
			search(){
				this.page.pageNum = 1;
				this.getserReacod()
			},
			//清空
			empty(){
				this.searchInfo = {}
			},
			// 设置额度按钮
			setport(){
				
				// this.ationFrom.subOrderDate =this.newTimer
				this.Quotatitle = '设置额度'
				this.setQuotaVisible = true
				// this.ationFrom.subOrderDate = new Data()
			},
			dateChange(e){
				// console.log(e);
			},
			edit(id){
				
				
			
				this.Quotatitle = '设置额度'
				this.setQuotaVisible = true
			
				this.recadId = id
				// this.ationFrom = {}
				if(id){
					this.Quotatitle = '编辑额度'
					this.setQuotaVisible = true
					// console.log(id);
					this.$api.setRocredList(this.$encrypt({id:id})).then(res=>{
						// console.log(res);
						res=JSON.parse(this.$decrypt(res.data))
						if(res.state == 'success'){
							this.ationFrom = res.data.list[0]
						}
					})
				}
				
				
			},
			
			// 新增额度
			set(){
				let data = {
					subOrderDate:this.ationFrom.subOrderDate,
					subOrderAmount:this.ationFrom.subOrderAmount
				}
				// console.log(data);
				this.$api.addRocerd(this.$encrypt(data)).then(res=>{
					// console.log(res);
					
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.setQuotaVisible = false
						this.getserReacod()
						this.ationFrom = {}
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			// 编辑额度
			updata(){
				let data ={
					subOrderAmount:this.ationFrom.subOrderAmount,
					id:this.recadId
				}
				this.$api.updataRocerd(this.$encrypt(data)).then(res=>{
					// console.log(res);
					
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.setQuotaVisible = false
						this.getserReacod()
						
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
			},
			chakan(id){
				this.ationFrom = {}
				this.chakanVisible = true
				this.$api.setRocredList(this.$encrypt({id:id})).then(res=>{
					// console.log(res);
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.ationFrom = res.data.list[0]
					}
				})
			},
			//分页
			pageChange(data) {
				this.page.pageNum = data
				this.getserReacod()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getserReacod()
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			getData(){
				const now = new Date();
				const year = now.getFullYear();
				const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 数字转字符串，并保证是两位数，不足则在前面填充 0
				const day = now.getDate().toString().padStart(2, '0');
				this.newTimer = `${year}-${month}-${day}`;
				
			},
			getnowData(){
				const now = new Date();
				const year = now.getFullYear();
				const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 数字转字符串，并保证是两位数，不足则在前面填充 0
				const day = now.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
				
			},
			getserReacod(){
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.setRocredList(this.$encrypt(data)).then(res=>{
					// console.log(res);
					res=JSON.parse(this.$decrypt(res.data))
					// console.log(res);
					if(res.state == 'success'){
						this.recardData = res.data
						// console.log(this.recardData);
					}
				})
			}
		},
		created() {
		
			this.getserReacod()
			this.getData()
		}
	}
</script>

<style scoped lang="less">
	/deep/.el-input__inner{
		color: black !important;
	}
</style>